module.exports = new __parcel__URL__("boar.15310caf.svg").toString();